import React from 'react';
import PropTypes from 'prop-types';
import { MapsLinkIcon } from '../../../../Maps/index';

function Address (props) {
  const item = props.item;
  const rawItem = props.rawItem;
  const geoLocation = item.getProperty().getGeoLocation();
  const link = item.getLink();

  return (
    <td className='paper col-address'>
      <MapsLinkIcon realtyObject={item} />

      <a
        target='_blank'
        className='location'
        href={link}
        onClick={() => {
          props.eventClickAnnouncement(rawItem);
        }}
      >
        {geoLocation.getShortAddress()}
      </a>
    </td>
  );
}

Address.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  eventClickAnnouncement: PropTypes.func.isRequired
};

export default Address;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/Address.jsx